// import logo from "./logo.svg";
// import "./App.css";

// function App() {
//   return (
//     <div className="App">
//       <header className="App-header">
//         <h1 className="text-3xl font-bold underline text-center mt-10">
//           Welcome to Ask Legal Vision
//         </h1>
//       </header>
//     </div>
//   );
// }

// export default App;

import React, { useState } from "react";
import ConsultationModal from "./Components/ConsultationModal";
import FeedbackForm from "./Components/FeedbackForm";

export default function App() {
  const [isModalOpen, setModalOpen] = useState(false);

  const openModal = () => setModalOpen(true);
  const closeModal = () => setModalOpen(false);

  return (
    <div className="font-sans text-gray-800 w-full p-0.5">
      {/* Consultation Modal */}
      {isModalOpen && <ConsultationModal onClose={closeModal} />}

      {/* Hero Section */}
      <section
        className="relative text-white px-2 py-8 sm:px-4 sm:py-10 md:px-6 md:py-12 h-[50vh] md:h-[75vh] lg:h-[90vh] xl:h-[95vh] overflow-hidden"
        style={{
          backgroundImage: "url('img/Legal1.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="bg-[#00000061] absolute top-0 left-0 w-full h-full flex items-center justify-center">
          <div className="max-w-5xl w-full px-2 sm:px-4 text-center md:text-left">
            <div className="flex flex-col sm:flex-row justify-center md:justify-start items-center mb-4 space-y-1 sm:space-y-0 sm:space-x-2">
              <div className="bg-white text-[#0c1a2b] px-3 py-1 font-bold font-serif text-base sm:text-lg md:text-xl">
                ASK
              </div>
              <div className="text-white text-base sm:text-lg md:text-xl font-bold tracking-wide">
                LEGAL VISION
              </div>
            </div>

            <h1 className="text-lg sm:text-2xl md:text-4xl lg:text-5xl font-semibold leading-snug md:leading-tight mb-4">
              Precision Legal Strategy
              <br />
              for a Fast-Moving World
            </h1>

            <p className="text-[10px] sm:text-xs mb-6">
              Advocate, Bombay High Court | HR Legal Solutions Expert
            </p>

            <div className="flex flex-col sm:flex-row justify-center md:justify-start gap-2">
              <button
                onClick={openModal}
                className="bg-white text-[#0c1a2b] px-4 py-2 rounded text-xs sm:text-sm"
              >
                BOOK A CONSULTATION
              </button>
              <button className="border border-white px-4 py-2 rounded text-xs sm:text-sm">
                CALL NOW
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="bg-gray-100 px-6 py-12">
        <div className="max-w-5xl mx-auto text-center md:text-left">
          <h2 className="text-2xl font-bold mb-4">
            Meet Adv. Aditya Shankar Kharche
          </h2>
          <div className="text-gray-700 space-y-4">
            <p>
              20+ years in legal practice, serving Specializing in Employment
              Law, Civil Litigation and Compliance
            </p>
            <p>Representing Bombay Legal precision with human insight</p>
            <ul className="list-disc list-inside">
              <li>
                Passion in Employment Law, Civil Litigation, and Compliance
              </li>
              <li>Member, Join Bar Council, Legal Hit Advisory Boards</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="px-6 py-12">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-2xl font-bold text-center mb-8">
            Legal Services Offered
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-5 gap-6 text-center text-sm">
            {/* Service Items */}
            {[
              "scales",
              "briefcase",
              "business-building",
              "book-stack",
              "training",
            ].map((img, idx) => (
              <div key={idx} className="flex flex-col items-center">
                <img src={`img/${img}.svg`} className="w-8 lg:w-12" alt={img} />
                <p>
                  {
                    [
                      "Litigation & Representation",
                      "Employment & Labour Law",
                      "Corporate & HR Legal Advisory",
                      "Legal Drafting & Compliance",
                      "Training for Businesses",
                    ][idx]
                  }
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials & Contact Section */}
      <section className="bg-gray-100 px-6 py-12">
        <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-8">
          {/* Testimonials */}
          <div>
            <h3 className="text-xl font-bold mb-4">Testimonials</h3>
            <p className="mb-4">
              “ASK Legal Vision gave us clarity and confidence during a tough HR
              case. Highly recommended.”
              <br />
              <span className="italic">— HR Manager, Mumbai Firm</span>
            </p>
            <p>
              “Sharp, honest, and strategic. Aditya sir's courtroom presence is
              unmatched.”
            </p>
          </div>

          {/* Contact and Feedback */}
          <div>
            <h3 className="text-xl font-bold mb-4">Contact</h3>
            <p className="mb-2">
              <a href="tel:+91961986239" className="hover:underline">
                📞 961986239
              </a>
            </p>
            <p className="mb-4">
              <a href="mailto:adikharche@gmail.com" className="hover:underline">
                ✉️ adikharche@gmail.com
              </a>
            </p>
            <p className="mb-4">🔗 LinkedIn</p>

            {/* Feedback Form */}
            <FeedbackForm />
          </div>
        </div>
      </section>
    </div>
  );
}
